import Config from '../helper/config'
import * as CryptoJs from 'crypto-js'
import CommonFunction from './commonfucnctioncomponet';
import { toast } from 'react-toastify'

let commonfunc = null;

export const isEmpty = value =>
value === undefined ||
value === null ||
value == false ||
value == 'false' ||
(typeof value === 'object' && Object.keys(value).length === 0) ||
(typeof value === 'string' && value.trim().length === 0) ||
(typeof value === 'string' && value == '0')||
(typeof value === 'number' && value === 0);

export const NumANdDotOnly = (data) => {
  var data = data.toString()
 var str = data ? data.includes('.') ? data.split('.').length >=3 ? (data.split('.')[0] + '.' + data.split('.')[1]).toString() : data : data : data
   return str.toString().replace(Config.NumDigitOnly,'')
 }

export const NumberOnly = (data) => {
  return data.toString().replace(Config.NumOnly,'')
}

// Common Formdata function
export const AppenData = (data) => {
  var formdata = new FormData()
  var SendDta = Object.entries(data).map((item) => {
      if (Array.isArray(item[1])) {
          var come = item[1].map(data => {
              if (data?.type && data?.size) {
                  //file
                  formdata.append(item[0], data)
              }
              else {
                  formdata.append(item[0], EncryptData(data))
              }
              return formdata
          })
          return come

      }
      else {
          if (item[1]?.type && item[1]?.size) {
              //file type
              formdata.append(item[0], item[1])
          }
          else {
              formdata.append(item[0], EncryptData(item[1]))

          }
          return formdata
      }
  })
  return [formdata]
}

export const EncryptData = (data) => {
  if(typeof(data)=='string'){
    return  CryptoJs.AES.encrypt(data,Config.KEY).toString()
  }
  else{
    return  CryptoJs.AES.encrypt(JSON.stringify(data),Config.KEY).toString()
  }
}

export const DecryptData = (data) => {
  try{
  var bytes = CryptoJs.AES.decrypt(data, Config.KEY);
  
  var decryptedData;
  try {
    decryptedData = JSON.parse(bytes.toString(CryptoJs.enc.Utf8));
  }
  catch (err) {
    
    try {
      decryptedData = bytes.toString(CryptoJs.enc.Utf8);
      

    }
    catch (dcpterr) {
      
      return undefined;
    }
  }
  return decryptedData;
  }
  catch(error){
    
    return undefined;
  }
}

const hasHeader = (headers, headerName) =>
  Object.keys(headers).some(
    (key) => key.toLowerCase() === headerName.toLowerCase()
  );

const deleteHeader = (headers, headerName) => {
  Object.keys(headers).forEach((key) => {
    if (key.toLowerCase() === headerName.toLowerCase()) {
      delete headers[key];
    }
  });
}

const appendSearchParam = (searchParams, key, value) => {
  if (value === undefined || value === null) {
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item) => appendSearchParam(searchParams, `${key}[]`, item));
    return;
  }

  if (typeof value === 'object') {
    Object.entries(value).forEach(([nestedKey, nestedValue]) => {
      appendSearchParam(searchParams, `${key}[${nestedKey}]`, nestedValue);
    });
    return;
  }

  searchParams.append(key, value);
};

const buildUrlWithParams = (url, params) => {
  if (!params || typeof params !== 'object') {
    return url;
  }

  let parsedUrl;
  let isRelativeUrl = false;

  try {
    parsedUrl = new URL(url);
  }
  catch (err) {
    isRelativeUrl = true;
    parsedUrl = new URL(
      url,
      typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
    );
  }

  Object.entries(params).forEach(([key, value]) => {
    appendSearchParam(parsedUrl.searchParams, key, value);
  });

  return isRelativeUrl
    ? `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`
    : parsedUrl.toString();
};

const parseResponseData = async (response) => {
  const responseText = await response.text();

  if (!responseText) {
    return responseText;
  }

  try {
    return JSON.parse(responseText);
  }
  catch (err) {
    return responseText;
  }
};

const fetchAdapter = async (requestData) => {
  const headers =
    requestData?.headers && typeof requestData.headers === 'object'
      ? { ...requestData.headers }
      : {};

  const requestOptions = {
    method: requestData?.method ? requestData.method.toUpperCase() : 'GET',
    headers,
  };

  if (requestData?.data !== undefined) {
    if (requestData.data instanceof FormData) {
      deleteHeader(headers, 'Content-Type');
      requestOptions.body = requestData.data;
    }
    else {
      if (!hasHeader(headers, 'Content-Type')) {
        headers['Content-Type'] = 'application/json';
      }
      requestOptions.body = JSON.stringify(requestData.data);
    }
  }

  const response = await fetch(
    buildUrlWithParams(requestData?.url, requestData?.params),
    requestOptions
  );

  if (!response.ok) {
    throw new Error(response.statusText || 'Request failed');
  }

  return {
    data: await parseResponseData(response),
    status: response.status,
    statusText: response.statusText,
    headers: response.headers,
    ok: response.ok,
  };
};

// Common Axios Function

export const axiosFunc = async (data) => {
  try {
    let Resp = {};
    // if(data?.url?.includes('/user/test')){
    // if(false){
    if (data?.params) {
      data.params = { data: (data.params) }
    }
    else if (data?.data) {
      if (!(data?.data instanceof FormData)) {
        data.data = { data: EncryptData(data.data) }
      }
    }
    // }
    // }
    let token = ("; " + document.cookie)
      .split(`; ${Config.cookiename}=`)
      .pop()
      .split(";")[0];
    if (token) {
      if(data.headers && typeof(data.headers)=='object'){
        deleteHeader(data.headers, 'Authorization');
        data.headers.Authorization = token;
      }
      else{
        data.headers = {
          'Authorization': token
        };
      }
    }
    Resp = await fetchAdapter(data)
    if (Resp?.data) {
      Resp.data = isEmpty(DecryptData(Resp.data)) ? Resp.data : DecryptData(Resp.data)
    }
    if(!Resp?.data?.status){
      if(Resp?.data?.data?.reLogin){
        removeLoginToken();
        // toast.error(Resp?.data?.msg??"Login Again")
        window.location.href = `${Config.FRONT_URL}/login`;
      }
    }
    console.log('datttaa',Resp?.data)
    return Resp
  }
  catch (e) {
    console.log('axiosFunc error', e)
    return { data: { success: 'error', msg: "Axios Error", data: null } }
  }
}

export const ImgEmpty = (data) => {
  try {
    return (
      (typeof (data) == 'object' && !data?.type) ||
      data === undefined ||
      data == "undefined" ||
      data === null ||
      (typeof data === 'string' && data.trim().length === 0) ||
      (typeof data === 'string' && data === '0') ||
      (typeof data === 'number' && data === 0)
    )
  }
  catch(err){
    console.log('ImgEmpty_error',err)
    return false
  }
}

export const ImgUrl = (data) => {
  try{
    return URL.createObjectURL(data);
  }
  catch(err){
    console.log('ImgUrl_error',err)
    return ''
  }
}

export const FirstCaps = (data) => {
  try{
    return data[0].toLocaleUpperCase() + data.slice(1);
  }
  catch(err){
    console.log('FirstCaps_error',err)
    return data
  }
};



export const MinuteHourFormat = (data) => {
  data = Number(isEmpty(data) ? 0 : data);
  return (data < 10 ? "0" : "") + data;
};

export const DateTimeForm = (date, datealone, timealone, ampm) => {
  try {
    if (datealone) {
      return `${MinuteHourFormat(new Date(date)?.getMonth() + 1)}/
      ${MinuteHourFormat(new Date(date)?.getDate())}/
      ${MinuteHourFormat(new Date(date)?.getFullYear())}`;
    } else if (timealone) {
      if (ampm) {
        return `${MinuteHourFormat(
          new Date(date)?.getHours() > 12
            ? new Date(date)?.getHours() - 12
            : new Date(date)?.getHours()
        )}:${MinuteHourFormat(new Date(date)?.getMinutes())} ${
          new Date(date)?.getHours() >= 12 ? "PM" : "AM"
        }`;
      } else {
        return `${MinuteHourFormat(
          new Date(date)?.getHours()
        )}:${MinuteHourFormat(new Date(date)?.getMinutes())} `;
      }
    } else if (ampm) {
      return `
      ${MinuteHourFormat(new Date(date)?.getMonth() + 1)}/
      ${MinuteHourFormat(new Date(date)?.getDate())}/
      ${MinuteHourFormat(new Date(date)?.getFullYear())}, ${MinuteHourFormat(
        new Date(date)?.getHours() > 12
          ? new Date(date)?.getHours() - 12
          : new Date(date)?.getHours()
      )}:${MinuteHourFormat(new Date(date)?.getMinutes())} ${
        new Date(date)?.getHours() >= 12 ? "PM" : "AM"
      } `;
    }
    return `
      ${MinuteHourFormat(new Date(date)?.getMonth() + 1)}/
      ${MinuteHourFormat(new Date(date)?.getDate())}/
      ${new Date(date)?.getFullYear()},${MinuteHourFormat(
      new Date(date)?.getHours()
    )}:${MinuteHourFormat(new Date(date)?.getMinutes())} `;
  } catch (err) {
    console.log("DateTimeForm_error", err);
    return "No Date";
  }
};

export const HideEmailId = (emailid) => {
  try{
      if(typeof(emailid)=='string'){
          let emailarr = emailid.split('@')
          return emailid.slice(0,3)+'.......'+( emailarr.length > 3 ?  emailarr[emailarr.length-2].slice(-2) : "")+"@"+emailarr[emailarr.length-1]
      }
      else{
          return emailid
      }
  }
  catch(err){
      console.log('HideEmailId_error',err)
      return emailid
  }
}

export const NumberChange = (data) => {
  try{
    return (isNaN(Number(data)) ? 0 : Number(data))
  }
  catch(err){
    console.log('NumberChange_error',err)
    return 0;
  }
}

export const GetCookie = () => {
  try{
    const usertoken = ("; " + document.cookie)
		.split(`; ${Config.cookiename}=`)
		.pop()
		.split(";")[0];
    return usertoken;
  }
  catch(err){
    console.log('GetCookie_error',err)
  }
}

export const removeLoginToken = () => {
  commonfunc?.clearRedux?.();
  if (Config.domainname == 'localhost') {
    document.cookie = Config.cookiename + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
  else {
    document.cookie = Config.cookiename + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" + Config.domainname + ";";
  }
}

export function UseHook () {
  commonfunc = CommonFunction()
  return(
    <></>
  )
}
